<template>
  <div v-if="requireLogin || !havePermission" class="login-require">
    <div v-if="requireLogin" class="modal-login__main">
      <div class="modal-login__title">
        {{ $t("common.ban_can_dang_nhap") }}
      </div>
      <div class="modal-login__button">
        <button @click="login()" class="btn-secondary btn-fill-secondary">
          {{ $t("common.dang_nhap") }}
        </button>
      </div>
    </div>
    <div v-else-if="!havePermission" class="modal-login__main">
      <div class="modal-login__title" style="font-size: 18px">
        {{ $t("common.thong_bao") }}
      </div>
      <div class="modal-alert">
        {{ $t("common.ban_can_nang_cap_tai_khoan") }}
        <span style="color: red">1900 638 088</span>
      </div>
    </div>
  </div>
</template>

<script>
import { APP_CONFIG } from "@/contants";
import { uuid } from "vue-uuid";
import { TokenService } from "@/api/storageService";
import authService from "@/api/authService";

export default {
  props: ["pageId"],
  data() {
    return {
      state: uuid.v1(),
      role: "",
      token: "",
      requireLogin: false,
      havePermission: true,
      permission: {},
    };
  },
  created() {
    this.getPermission();
  },
  methods: {
    getPermission() {
      authService
        .getPermission()
        .then((response) => {
          if (response.status == 200) {
            let per = response.data.filter(
              (item) => item.FUNCTION_ID == this.pageId
            );
            this.permission = per !== null ? per[0] : null;
            if (this.permission !== null) {
              if (this.permission?.AUTHOR_MASS === "Y") {
                this.checkTokenExpire();
              }
            }
          } else {
            messageBox.showWarning("Có lỗi xảy ra");
          }
        })
        .finally(() => {
          this.loadding = false;
        });
    },

    checkTokenExpire() {
      authService
        .checkTokenExpire()
        .then((response) => {
          if (response.status === 200) {
            this.requireLogin =
              response.data !== null ? response.data.Expired : true;
            if (!this.requireLogin) {
              const role = TokenService.getRole();
              if (this.permission.AUTHOR_VIP == "Y") {
                if (role === "vip") {
                  this.havePermission = true;
                } else {
                  this.havePermission = false;
                }
              }
            }
          }
        })
        .finally();
    },

    login() {
      this.state = uuid.v1();
      let url =
        APP_CONFIG.ssoUrl +
        "/sso/oauth/authorize?client_id=" +
        APP_CONFIG.ssoClientId +
        "&response_type=code&redirect_uri=" +
        APP_CONFIG.webUrl +
        "/callback&scope=general&state=" +
        this.state +
        "&ui_locales=vi&loginWithAnother=true&webtrade=true&language=vi&name=&username=&theme=dark";

      window.location.href = url;
    },
  },
};
</script>

<style scoped>
.login-require {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2000;
  backdrop-filter: blur(4px);
}
.modal-login__main {
  background: var(--bg-popup-permission);
  position: relative;
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 13px;
  border-radius: 10px;
  margin: 150px auto;
  z-index: 9999;
}
.modal-login__title {
  font-size: 16px;
  padding-bottom: 10px;
}
.modal-alert {
  font-size: 14px;
}
.modal-login__button {
  padding-top: 20px;
}
.modal-login__button button {
  padding: 3px 20px;
  font-size: 15px;
}
</style>
